import React from 'react';
import SMCategoryReputationListView from './SMCategoryReputationListView';
import SMCategoryHomeSearchFormView from './SMCategoryHomeSearchFormView';
import SMSearchListTableRow from 'components/search/SMSearchListTableRow';
import SMUserResource from 'resources/SMUserResource';
import SMRestClient from 'lib/SMRestClient';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import sprintf from 'sprintf';
import moment from 'moment';
import SMConst from 'lib/SMConst';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMUFavoriteListSelectView from 'components/dashboard/users/SMUFavoriteListSelectView';

class SMCategoryHomeView extends React.Component {

  constructor(props) {
    super(props);
    let reputation = null;
    if (props.reputations.length > 0) {
      const index = Math.floor(Math.random() * props.reputations.length) ;
      reputation = props.reputations[index];
    }

    this.state = {
      rooms: this.props.rooms,
      links: SMRestClient.parseLinkString(this.props.linkString),
      reputation: reputation,
      latestUpdatedFavoriteList: {},
      targetFavoriteRoom: {},
      isSMUFavoriteListSelectViewOpen: false,
    };

  }

  componentDidMount() {
    SMRenderHelper.addObserverForBaloon();
    SMTrackHelper.criteoList(this.props.currentUser ? this.props.currentUser.email : "", this.props.rooms);
  }

  // SMSearchListTableRow delegate
  favoriteDidSelect(favorable, isFavorite, rowIndex) {
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }
    if (isFavorite) {
      // もしお気に入りに登録されている場合はリスト選択のモーダルを表示
      this.showFavoriteListSelectForm(favorable);
    } else {
      let room = favorable;
      let responseHandler = (data, error, xhr)=>{
        let rooms = this.state.rooms;
        if (error) {
          return;
        } else {
          room.is_favorite = true;
          room.registered_favorite_lists.push(data.favorite_list.id);
          rooms[rowIndex] = room;
          this.setState({
            rooms: rooms,
            latestUpdatedFavoriteList: data.favorite_list,
          });
        }
      };
      SMUserResource.postFavorite(this.props.currentUser.username, room.id, 'Room', responseHandler);
    }
  }

  showFavoriteListSelectForm(room, e){
    if (e) e.preventDefault();
    this.setState({
      targetFavoriteRoom: room,
      isSMUFavoriteListSelectViewOpen: true,
    });
  }

  // SMSearchListTableRow delegate
  favoriteListSelectViewDidClose() {
    this.setState({
      isSMUFavoriteListSelectViewOpen: false,
    });
  }

  splitLargeAreaHasMediumOrNot(largeAreas) {
    let splits = [[],[]];
    largeAreas.forEach((largeArea)=>{
      splits[largeArea.medium_areas.length > 0 ? 0 : 1].push(largeArea);
    });
    return splits;
  }

  render() {
    const reputation = this.state.reputation;
    const requestQueries = this.props.requestQueries;
    const rooms = this.state.rooms;
    let user, reservation, room;
    let coverImageUrl = SMRailsBridge.assetPath.categoryTopDefaultCover;

    if (reputation) {
      user = reputation.from;
      reservation = reputation.reputatable;
      room = reservation.room;
      if (room.thumbnails.length > 0) coverImageUrl = room.thumbnails[0].image;
    }
    else if (rooms.length > 0) {
      room = rooms[0];
      if (room.thumbnails.length > 0) coverImageUrl = room.thumbnails[0].image;
    }

    if (coverImageUrl) {
      if (!SMAppHelper.isMobile()) {
        coverImageUrl = SMFormatHelper.imageURLWithTransform(coverImageUrl, {width: 1200, height: 670});
      }
    }
    let featureAreas = [];
    let mediumAreas = [];
    let stateNameText = '';
    let otherAreas = [];

    this.props.countries.map((country)=>{
      if (country.id != 1) return;
      country.regions.map((region)=>{
        region.large_areas.forEach((largeArea)=>{
          if (largeArea.medium_areas.length > 0) {
            if (requestQueries.state) {
              if (largeArea.name != requestQueries.state) {
                return;
              }
              stateNameText = largeArea.name_text;
              largeArea.medium_areas.map((mediumArea)=>{
                mediumAreas.push(mediumArea);
              });
            } else {
              featureAreas.push(largeArea);
            }
          } else {
            if (!requestQueries.location) {
              otherAreas.push(largeArea);
            }
          }
        });
      });
    });

    let evenCount = -1;

    return(
      <div className="site-main">
        <div className="mod-heroimg"><img src={coverImageUrl} alt="" className="mod-heroimg__img" />
          <div className="mod-heroimg__bg">
            <h1 className="mod-heroimg__title">{this.props.title}
              {(()=>{
                if (!reputation) return null;
                return (
                  <span className="catetop-heroimg__review">
                    <a href={Routes.user_path(user.username)}><img src={user.profile_image} alt={user.name} className="catetop-heroimg__review-guest is-hover" /></a>
                    <span className="catetop-heroimg__review-content">{reputation.description}</span>
                  <span className="catetop-heroimg__review-name"><a href={Routes.user_path(user.username)}>{user.name}</a><a href={Routes.space_room_path(room.space.username, room.uid)}>{SMFormatHelper.roomName(room)}</a> へのレビュー</span>
                  </span>
                );
              })()}
            </h1>
          </div>
        </div>

        <div className="catetop-search">
          <div className="search-box">
            <form action={Routes.search_index_path()} method="get">
              <SMCategoryHomeSearchFormView
                eventType={requestQueries.event_type}
                priceType={'hourly'}
                location={requestQueries.location}
                minCapacity={requestQueries.capacity}
                capacityList={this.props.capacityList}
                spaceType={requestQueries.space_type}
                amenities={requestQueries.amenities}
              />
            </form>
          </div>
        </div>

        {/* <div className={`page__${++evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
          <div className="container">
            <h2 className="catetop__head-title">{this.props.catchTitle}</h2>
            <p className="catetop-lead__content">{this.props.description}</p>
          </div>
        </div> */}

        <div className={`page__${(++evenCount) % 2 == 0 ? 'even' : 'odd'} page__padding`}>
          <div className="container">
            <h2 className="catetop__head-title">{this.props.title}ランキング TOP3</h2>
            <ul className="row">
            {rooms.map((room, index) => {
              return (
                <SMSearchListTableRow
                  key={room.id}
                  hasRank={true}
                  showBaloon={true}
                  room={room}
                  noRoomImage={this.props.noRoomImage}
                  rowIndex={index}
                  canSlide={true}
                  options={{className: 'col-xs-12 col-md-4 units-item'}}
                  delegate={this}
                  latestUpdatedFavoriteList={this.state.latestUpdatedFavoriteList} />
              );
            })}
            </ul>
            {(()=>{
              if (rooms.length < 3) return null;
              return (
                <div className="mod-more__area">
                  <a href={`${this.props.requestPath}/ranking`} className="button-blue mod-more__area-button">ランキングをもっと見る</a>
                </div>
              );
            })()}
          </div>
        </div>

        {(()=>{
          if (!reputation) return null;
          return (
            <div className={`page__${++evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
              <div className="container">
                <h2 className="catetop__head-title">新着レビュー</h2>
                <ul className="row">
                  {this.props.reputations.map((reputation)=>{
                    const reservation = reputation.reputatable;
                    const date = reservation.stay_checkin_at ? reservation.stay_checkin_at : reservation.started_at;
                    const user = reputation.from;
                    const room = reservation.room;
                    const start = sprintf(I18n.t("service.label_000002"),
                      moment(date).utc().format(I18n.t("datetime.label_000002")));
                    return (
                      <li key={reputation.id} className="col-xs-12 col-md-4">
                        <a href={Routes.user_path(user.username)}><img src={user.profile_image} alt={user.name} className="is-hover catetop-rewiew__guest" /></a>
                        <div className="catetop-review__head">
                          <p className="catetop-review__name"><a href={Routes.user_path(user.username)}>{user.name}</a><span className="catetop-review__date">{start}</span></p>
                          <p className="catetop-review__space"><a href={Routes.space_room_path(room.space.username, room.uid)}>{SMFormatHelper.roomName(room)}</a></p>
                        </div>
                        <a className="catetop-review__content is-hover" href={Routes.space_room_path(room.space.username, room.uid)}>
                          <p className="catetop-review__content-inner">
                            {reputation.description}
                          </p>
                        </a>
                      </li>
                    );
                  })}
                </ul>
                {(()=>{
                  if (this.props.reputations.length < 3) return null;
                  return (
                    <div className="mod-more__area">
                      <a href={`${this.props.requestPath}/reputations`} className="button-blue mod-more__area-button">新着レビューをもっと見る</a>
                    </div>
                  );
                })()}
              </div>
            </div>
          );
        })()}


        {(()=>{
          if (requestQueries.event_type) return null;
          return (
            <div className={`page__${++evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
              <div className="container">
                <h2 className="catetop__head-title">目的で絞り込む</h2>
                <ul className="row">
                  {this.props.eventTypeList.map((eventType)=>{
                    let queries = {};
                    for(let key in requestQueries){
                      queries[key] = requestQueries[key];
                    }
                    queries.eventType = eventType.name;
                    return (
                      <li key={eventType.id} className="col-xs-12 col-md-4 col-lg-3">
                        <a href={`/event_types/${eventType.name}${this.props.requestPath}`} className="catetop-conditions__condition is-hover"><h3>{eventType.name_text}</h3></a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          );
        })()}

        {(()=>{
          if (this.props.features.length == 0) return null;
          return (
            <div className={`page__${++evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
              <div className="container">
                <h2 className="catetop__head-title">関連するまとめ</h2>
                <div className="row">
                {this.props.features.map((feature) => {
                  return (
                    <div key={feature.id} className="col-sm-12 col-md-4 matome-box">
                      <a href={Routes.feature_path(feature.uid)}>
                        <div className="matome-linkbox">
                          <img src={feature.image} alt={feature.title} className="is-hover" />
                          <h3 className="matome-subtitle">{feature.title}</h3>
                        </div>
                      </a>
                    </div>
                  );
                })}
                </div>
                {(()=>{
                  if (this.props.features.length < 3) return null;
                  return (
                    <div className="mod-more__area">
                      <a href={`${this.props.requestPath}/features`} className="button-blue mod-more__area-button">関連するまとめをもっと見る</a>
                    </div>
                  );
                })()}
              </div>
            </div>
          );
        })()}

        {(()=>{
          if (featureAreas.length == 0) return null;
          return (
            <div className={`page__${++evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
              <div className="container">
                <h2 className="catetop__head-title">注目のエリア</h2>
                <div className="row">
                  {featureAreas.map((featureArea)=>{
                    return (
                      <div key={featureArea.name} className="col-xs-12 col-md-15 matome-box">
                        <a href={`${this.props.requestPath}/areas/${featureArea.name}`}>
                          <img src={SMRailsBridge.assetPath[`categoryTopArea_${featureArea.name}`]} alt="" className="is-hover w100per" />
                          <h3 className="catetop-area__title">{featureArea.name_text}</h3>
                        </a>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })()}

        {(()=>{
          if (mediumAreas.length > 0) {
            return (
              <div className={`page__${++evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
                <div className="container">
                  <h2 className="catetop__head-title">人気のエリアで絞り込む</h2>
                  <ul className="row">
                    {mediumAreas.map((mediumArea)=>{
                      let queries = {};
                      for(let key in requestQueries){
                        queries[key] = requestQueries[key];
                      }
                      queries.location = stateNameText + mediumArea.name_text;
                      return (
                        <li key={mediumArea.id} className="col-xs-6 col-md-2">
                          <a href={Routes.search_index_path(queries)} className="catetop-conditions__condition is-hover"><h3>{mediumArea.name_text}</h3></a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            );
          }
          else if (otherAreas.length > 0) {
            return (
              <div className={`page__${++evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
                <div className="container">
                  <h2 className="catetop__head-title">エリアで絞り込む</h2>
                  {this.props.countries.map((country)=>{
                    if (country.id != 1) return null;
                    return country.regions.map((region)=>{
                      return (
                        <div key={region.id}>
                          <h3 className="catetop__head-title__area">{region.name_text}</h3>
                          <ul className="row">
                          {region.large_areas.map((largeArea)=>{
                            let queries = {};
                            for(let key in requestQueries){
                              queries[key] = requestQueries[key];
                            }
                            queries.location = largeArea.name_text;
                            return (
                              <li key={largeArea.id} className="col-xs-6 col-md-2">
                                <a href={Routes.search_index_path(queries)} className="catetop-conditions__condition is-hover"><h3>{largeArea.name_text}</h3></a>
                              </li>
                            );
                          })}
                          </ul>
                        </div>
                      );
                    });
                  })}
                </div>
              </div>
            );
          }
        })()}

        {(()=>{
          if (requestQueries.capacity) return null;
          return (
            <div className={`page__${++evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
              <div className="container">
                <h2 className="catetop__head-title">人数で絞り込む</h2>
                <ul className="row">
                  {this.props.capacityList.map((capacity)=>{
                    let queries = {};
                    for(let key in requestQueries){
                      queries[key] = requestQueries[key];
                    }
                    queries.capacity = capacity.name;
                    return (
                      <li key={capacity.id} className="col-xs-6 col-md-2">
                        <a href={Routes.search_index_path(queries)} className="catetop-conditions__condition is-hover"><h3>{capacity.name}人〜</h3></a>
                      </li>
                    );
                  })}
                </ul>
              </div>
              {/* <div className="mod-more__area">
                <a href="/capacities" className="button-blue mod-more__area-button">人数一覧を見る</a>
              </div> */}
            </div>
          );
        })()}

        {(()=>{
          if (requestQueries.amenities) return null;
          return (
            <div className={`page__${++evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
              <div className="container">
                <h2 className="catetop__head-title">アメニティで絞り込む</h2>
                <ul className="row">
                  {this.props.amenityList.map((amenity)=>{
                    if (amenity.amenity_type == SMConst.AmenityType.Stay) return null;
                    let queries = {};
                    for(let key in requestQueries){
                      queries[key] = requestQueries[key];
                    }
                    queries.amenities = amenity.name;
                    return (
                      <li key={amenity.id} className="col-xs-12 col-md-4 col-lg-3">
                        <a href={Routes.search_index_path(queries)} className="catetop-conditions__condition is-hover"><i className={`icon icon-spm-${amenity.name}`}></i><h3>{amenity.name_text}</h3></a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          );
        })()}

        {(()=>{
          if (requestQueries.space_type) return null;
          return (
            <div className={`page__${++evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
              <div className="container">
                <h2 className="catetop__head-title">会場タイプで絞り込む</h2>
                <ul className="row">
                  {this.props.spaceTypeList.map((spaceType)=>{
                    let queries = {};
                    for(let key in requestQueries){
                      queries[key] = requestQueries[key];
                    }
                    queries.space_type = spaceType.name;
                    return (
                      <li key={spaceType.id} className="col-xs-12 col-md-4 col-lg-15">
                        <a href={Routes.search_index_path(queries)} className="catetop-conditions__condition is-hover"><h3>{spaceType.name_text}</h3></a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          );
        })()}
        <SMUFavoriteListSelectView
          room={this.state.targetFavoriteRoom}
          delegate={this}
          user={this.props.currentUser}
          isOpen={this.state.isSMUFavoriteListSelectViewOpen}
          noFavoriteListImage={this.props.noFavoriteListImage} />
      </div>
    );
  }
}
export default SMCategoryHomeView;



// WEBPACK FOOTER //
// ./app/javascript/components/categories/SMCategoryHomeView.jsx